<template>
  <div>
    <template v-if="showPass">
      <div class="bg-white p-4 shadow-theme rounded-small mt-4">
        <div class="text-small text-theme-black-450 text-center leading-18">
          <div>
            <img src="~@/assets/img/answer/regret.png" alt="" width="132" />
          </div>
          <template v-if="!allowAwardWithoutFollow">
            <p>真遗憾，红包与您擦肩而过</p>
            <p>别灰心，进<span class="text-theme" @click="onWechart">“调研工厂+”</span>公众号，答其他红包问卷。</p>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="isOpenReward">
        <split-box class="mt-4" style="background-color: #ffd7d7">
          <template v-slot:top-content>
            <div class="text-center">
              <p class="mb-2">
              <span class="text-theme-black-850 text-small leading-22">
                <span v-if="enableNetManualAudit">恭喜您抽中红包，红包将在问卷发布人审核通过后发放</span>
                <span v-else>恭喜您抽中红包</span>
              </span>
              </p>
              <template v-if="awardYuanAmount">
                <span class="amount-of-money">{{ awardYuanAmount ? awardYuanAmount.toFixed(2) : '' }}</span>
                <span>元</span>
              </template>
            </div>
          </template>
          <template v-slot:bottom-content>
            <div class="text-center text-small leading-18 text-theme-black-450">
              <template v-if="hasUser">
                <template v-if="!allowAwardWithoutFollow || awardYuanAmount < 1">
                  <div v-if="enableNetManualAudit" class="text-left">
                    <div class="mb-2">
                      调研工厂 <span class="text-theme" @click="onShowWithdrawal">红包提现</span> 流程：
                    </div>
                    <div>
                      <span>1.点击并关注</span>
                      <span class="text-theme" @click="onWechart">“调研工厂+”</span>
                      <span>公众号</span>
                    </div>
                    <div>
                      <span>2. 等待问卷审核，最迟 72 小时内完成审核</span>
                    </div>
                    <div>
                      <span>3. 问卷审核通过“调研工厂+”公众号给您发放红包到账消息（审核不通过无推送）</span>
                    </div>
                    <div>
                      <span>4. 红包到账后，点击公众号底部菜单“我要提现”进行提现</span>
                    </div>
                  </div>
                  <div v-else>
                    <span>红包将在15分钟内到账，点击并关注</span>
                    <span class="text-theme" @click="onWechart">“调研工厂+”</span>
                    <span>公众号后，点击公众号底部菜单“我要提现”进行提现。</span>
                  </div>
                </template>
                <template v-else>
                  <div v-if="enableNetManualAudit" class="text-left">
                    <div>
                      请按步骤领红包：
                    </div>
                    <div>
                      <span>1. 等待问卷审核，最迟 72 小时内完成审核</span>
                    </div>
                    <div>
                      <span>2. 问卷审核通过后，红包将自动发放至您的微信零钱中</span>
                    </div>
                    <div>
                      <span>3. 建议您点击关注<span class="text-theme" @click="onWechart">“调研工厂+”</span>公众号，关注后可接收红包到账信息。</span>
                    </div>
                  </div>
                  <div v-else>
                      <span>红包将在15分钟内自动发放至您的微信零钱中</span>
                  </div>
                </template>
                <div v-if="isBindOtherAnswer">
                  <span>同一用户最多可以领取一次红包</span>
                </div>
              </template>
              <div v-else>
                <div v-if="!enableNetManualAudit">
                  <span>点击</span>
                  <span class="text-theme" @click="onAward">“领取奖励”</span>
                  <span>按步骤领红包。点击</span>
                  <span class="text-theme" @click="onWechart">“调研工厂+”</span>
                  <span>关注公众号，您可在公众号“我要提现”中进行提现。</span>
                </div>
                <div v-else>
                  <span>点击</span>
                  <span class="text-theme" @click="onAward">“领取奖励”</span>
                  <span>按步骤领红包。点击</span>
                  <span class="text-theme" @click="onWechart">“调研工厂+”</span>
                  <span>关注公众号，审核通过后，您可在公众号“我要提现”中进行提现。</span>
                </div>
              </div>
            </div>
          </template>
        </split-box>
      </template>
      <template v-else>
        <blessing-bag v-if="showBlessingBag" @click="openReward" :blessing-bag="blessingBag" />
        <red-reward-button v-else @click="openReward" />
      </template>
    </template>
  </div>
</template>

<script>
import { BoundFailedType, busGetters, hasValue } from 'dygc'
import SplitBox from '@/components/SplitBox'
import { createPopup } from '@/assets/js/factory'
import OfficialAccount from '@/components/overlay/OfficialAccount'
import ReceiveReward from '@/components/overlay/ReceiveReward'
import RedRewardButton from '@/components/base/RedRewardButton'
import { Dialog, ImagePreview } from 'vant'
import BlessingBag from 'components/blessing-bag/BlessingBag'

export default {
  name: 'EndAward',
  components: { RedRewardButton, SplitBox, BlessingBag },
  computed: {
    showPass(){
      const lottery = this.$bus.currentAwardData?.bindAward || {}
      const pass = lottery.boundStatus ===3 && lottery.boundFailedType === 2
      return (!this.hasReward) || (this.awardYuanAmount===0 && lottery.boundFailedType !== BoundFailedType.OTHER_EXCESS) || pass
    },
    redEnvelopesType() {
      return this.$bus.survey.otherSetting.redEnvelopesType
    },
    showBlessingBag() {
      return this.redEnvelopesType === 1
    },
    blessingBag() {
      return this.$bus.survey.otherSetting.blessingBag || { list: [], num: 0 }
    },
    awardYuanAmount() {
      const data = this.$bus.currentAwardData || {}
      return data.bindAward?.awardYuanAmount
    },
    isOpenReward(){
      return hasValue(this.awardYuanAmount)
    },
    allowAwardWithoutFollow() {
      return this.overData?.allowAwardWithoutFollow
    },
    hasReward() {
      return this.$bus.currentAwardData?.hasReward
    },
    hasUser() {
      return !!this.$bus.params.accountUserId
    },
    isBindOtherAnswer(){
      const bindAward = this.$bus.currentAwardData?.bindAward || {}
      return bindAward?.boundFailedType === BoundFailedType.OTHER_EXCESS // && this.bindAward.boundStatus===3
    },
    ...busGetters(['award', 'share', 'hadAward', 'hadShare', 'overData', 'enableNetManualAudit'])
  },
  methods: {
    openReward() {
      if (this.$bus.currentBrowserInfo.isWeixin) {
        if (!this.$bus.params.accountUserId) {
          Dialog.confirm({
            title: '微信授权提示',
            message: '为保证您能正常获得分享红包，请先进行微信授权',
            confirmButtonText: '去授权',
            cancelButtonText: '暂不授权'
          }).then(() => {
            this.$answerUtil.wxAuthorization('2')
          })
          return
        } else {
          this.$bus.openLoading()
          this.$bus.drawRewards().then((res)=>{
            // this.$bus.overData.awardYuanAmount = res.data.awardYuanAmount
            // this.$bus.currentAnswerData.bindAward = res.data
            this.$bus.currentAwardData.bindAward = res.data
          }).finally(()=>{
            this.$bus.closeLoading()
          })
        }
      }else {
        const answerData = this.$bus.currentAwardData || {}
        if(answerData.needAccountUserId && !this.$bus.params.accountUserId) {
          this.onAward()
        }else {
          this.$bus.openLoading()
          this.$bus.drawRewards().then((res)=>{
            // this.$bus.overData.awardYuanAmount = res.data.awardYuanAmount
            // this.$bus.currentAnswerData.bindAward = res.data
            this.$bus.currentAwardData.bindAward = res.data
          }).finally(()=>{
            this.$bus.closeLoading()
          })
        }
      }
    },
    onWechart() {
      createPopup(OfficialAccount)
    },
    onAward() {
      const url = this.$bus.getUrl(2)
      console.log(url)
      createPopup(ReceiveReward, {
        isTest: !!this.$bus.params.isTest,
        needAuditFlag: !!this.enableNetManualAudit,
        url
      })
    },
    onShowWithdrawal(){
      const instance = ImagePreview({
        images: ["https://wenjuanba-pro.oss-cn-beijing.aliyuncs.com/195967/image/2023-7-3/1688391327893crty_aaa.png?Expires=2023855333&OSSAccessKeyId=LTAI5tRH5yapgQhwWoNXMYrQ&Signature=7G0vjMq31MgaYfCJmvJafIDuXBo%3D"],
        closeable: true,
        onClose() {
          instance.close()
        }
      })
    }
  }
}
</script>
